import React, {useRef, useState, useEffect} from 'react';
import './common/css/login.css';
import {showToast, setCookie, setEncryptCookie} from './common/app_common.js';
import {LoadingSpinner} from './common/component_common.js';
import { postApiUserSignin, getApiSystemVersion } from './common/fetch_api/api_common';
// import axios from 'axios';

const PageLogin = ({setLogin}) => {
    const userInfo = useRef({
        id:'admin',
        password: null
    });

    const [showInput, setShowInput] = useState(false);

    const inputRef = useRef();
    const passwordRef = useRef();

    const [loading, setLoading] =useState(false);

    const onChangeSelect = e => {
        // e.preventDefault();
        if(e.target.value === 'none')
        {
            setShowInput(true);
        }
        else
        {
            setShowInput(false);
            userInfo.current.id = e.target.value;
        }

        passwordRef.current.focus();
    }

    const onChangeInput = e => {
        userInfo.current.id = e.target.value;
    }

    const onChangePassword = e => {
        userInfo.current.password = e.target.value;
    }

    const handleOnKeyPress = e => {
        if (e.key === 'Enter') {
          login();
        }
    };

    const login = e => {
        // e.preventDefault();
        setLoading(true);

        if( userInfo.current.id === '' || userInfo.current.password === '')
        {
            setLoading(false);
            showToast('Please check username and password!','error');
            
        }
        else
        {
            let urlencoded = new URLSearchParams();
            urlencoded.append("username", userInfo.current.id);
            urlencoded.append("password", userInfo.current.password);
    
            Promise.resolve( postApiUserSignin(urlencoded) )
            .then(data => 
            {
                // setLoading(false);
                const json = data[0];
                const response = data[1];
    
                let errorStatus = response.status;
                let errDetail = json.detail;
                
                setLoading(false);
                
                if (errorStatus !== 200)
                {
                    passwordRef.current.value = '';
                    passwordRef.current.focus();
                    showToast(errDetail,'error');
                }
                else
                {
                    let accessToken = json.accessToken;
                    let refreshToken = json.refreshToken;
                    let permission = json.permission;
                    let username = json.username;
                    
                    let date = new Date();
                    let acessExpDate = String(date.setTime(date.getTime() + 1000 * 60 * json.accessTokenExpMinute));
                    let refreshExpDate = String(date.setTime(date.getTime() + 1000 * 60 * json.refreshTokenExpMinute));
    
                    setCookie('accessToken', accessToken);
                    setCookie('accessTokenExp', acessExpDate);
                    setCookie('refreshToken', refreshToken);
                    setCookie('refreshTokenExp', refreshExpDate);
                    setEncryptCookie('type', permission);
                    setEncryptCookie('using', username);
                    // setCookie('tokenStatus', 'false');
    
                    setLogin();
                }
            })
            .catch(err => { setLoading(false); });
        }
    };

    const hrefCur = useRef('');
    useEffect( () => {
        hrefCur.current = window.location.href.replace('/#', '');
    }, [window.location.href]);

    const [versionInfo, setVersionInfo] = useState(null);
    useEffect(() => {
        Promise.resolve( getApiSystemVersion() )
        .then(data =>
        {
            setVersionInfo(data);
        })
        .catch(err => { });

        // if (inputRef.current) inputRef.current.focus();
        
    }, []);

    return (
        <div className='wrapper'>
            <div className="container">
                <div className="d-flex flex-column">
                    <div className="login-box">
                        <div className="d-flex login-title justify-content-center">OnAir MapX</div>
                        <div className="device-name">{versionInfo?versionInfo.systemName:''}</div>
                        <div className="form-group">
                            <label className="my-1">Username</label>
                            <select className="form-select form-select" name='id' onChange={onChangeSelect}>
                                <option value="admin">Admin</option>
                                <option value="operator">Operator</option>
                                <option value="monitoring">Monitoring</option>
                                <option value="none">Not Listed</option>
                            </select>
                            {showInput && <input type="text" ref={inputRef} className="form-control input-box mt-2" placeholder="Enter username" onChange={onChangeInput}></input>}
                        </div>
                        <div className="form-group mt-3">
                            <label className="mb-1">Password</label>
                            <input type="password" ref={passwordRef} className="form-control input-box" placeholder="Enter password" onChange={onChangePassword} onKeyDown={handleOnKeyPress}></input>
                        </div>
                        <div className="form-group mt-4">
                            <input type="button" className="btn btn-primary btn-md w-100" value="Sign in" onClick={login}></input>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer fixed-bottom">
                <span className="webVer">{versionInfo ? `web v1.0.16` : 'web version'}</span>
                <span> | </span>
                <span className="apiVer">{versionInfo ? `api v${versionInfo.server}` : 'api version'}</span>
            </div>
            <LoadingSpinner loading={loading}/>
        </div>
    )
  }

export default PageLogin;